
import React, { useEffect, useState, Fragment } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon, MailOpenIcon } from '@heroicons/react/outline'
import Paginate from './../../utils/Paginate';
import { convert, formatDate } from './../../utils/convertDate';
import DatePicker from 'react-date-picker';
import fire from './../../utils/Toastr';
import PosServices from './../../services/PosServices';



const statusStyles = {
    Successful: 'bg-green-500 text-white',
    Pending: 'bg-amber-400 text-white',
    Failed: 'bg-orange-600 text-white',
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}
export default function POSRequest() {
    const [req, setReq] = useState([]);
    const [search, setSearch] = useState("");
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("")
    const [status, setStatus] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [summ, setSummary] = useState({})

    const listReq = async () => {
        const resp = await PosServices.listPos(pageIndex, 10, search, fromm, too, status);
        setReq([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages)
        setNextPage(resp.data.hasNextPage);
        const sum = await PosServices.posSummary();
        setSummary(sum.data);
    }
    const approve = async (text) => {
        const resp = await PosServices.actionPos({
            posStatus: "Approved",
            customerUserName: text.userName,
            id: text.id
        });
        if (resp) {
            fire("success", resp.message);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }
    const reject = async (text) => {
        const resp = await PosServices.actionPos({
            posStatus: "Rejected",
            customerUserName: text.userName,
            id: text.id
        });
        if (resp) {
            fire("success", resp.message);
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }
    const handleStatus = async (text) => {
        if (text === "All") {
            const resp = await PosServices.listPos(pageIndex, 10, search, fromm, too, status);
            setReq([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages)
            setNextPage(resp.data.hasNextPage)
        } else {
            setStatus(text);
            const resp = await PosServices.listPos(pageIndex, 10, search, fromm, too, text);
            setReq([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount)
            setPageIndex(resp.data.pageIndex)
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages)
            setNextPage(resp.data.hasNextPage)
        }

    }

    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const resp = await PosServices.listPos(pageIndex, 10, search, convert(newDate), convert(toDate), status);
        setReq([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount)
        setPageIndex(resp.data.pageIndex)
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages)
        setNextPage(resp.data.hasNextPage)
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const exportCSV = async () => {
        const resp = await PosServices.exportPOS(search, fromm, too, status);
        window.open(resp.data);
    }
    const searchDeposit = async (text) => {
            setSearch(text);
    }
    useEffect(() => {
        listReq();
    }, [pageIndex])
    return (<>
        <Layout title={'POS Request'} current={'/pos'} pageTag={'pos'}>
            <React.Fragment>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                    <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-5">
                        <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                            <div className="absolute  rounded-md p-3">
                                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                            </div>
                            <div>
                                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total POS Request</p>
                                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalPosRequest}</p>
                            </div>
                        </div>
                        <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                            <div className="absolute  rounded-md p-3">
                                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                            </div>
                            <div>
                                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Approved</p>
                                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalApprovedPosRequest}</p>
                            </div>
                        </div>
                        <div className="relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                            <div className="absolute  rounded-md p-3">
                                <MailOpenIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
                            </div>
                            <div>
                                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Rejected</p>
                                <p className="text-2xl ml-12 font-semibold text-gray-900">{summ.totalRejectedPosRequest}</p>
                            </div>
                        </div>
                        <div className=" relative flex bg-white pt-5 px-4 pb-5 sm:pt-6 sm:px-6 shadow rounded-lg overflow-hidden">
                            <div className="absolute  rounded-md p-3">
                                <MailOpenIcon className="h-6 w-6 text-green-900" aria-hidden="true" />
                            </div>
                            <div>
                                <p className="ml-12 text-sm font-medium text-gray-500 truncate">Total Pending</p>
                                <p className="text-2xl ml-12 font-semibold text-green-900">{summ.totalPendingPosRequest}</p>
                            </div>
                        </div>

                    </dl>
                    <div className="mt-4 sm:mt-0 sm:ml-16  flex justify-end">
                        <button
                            type="button"
                            onClick={exportCSV}
                            className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                        >
                            <DocumentDownloadIcon className="w-4 mr-1.5" />
                            Export CSV
                        </button>
                    </div>
                    <div className="sm:flex sm:items-center mt-10">
                        <div className="sm:flex-auto flex">
                           
                           
                            <div className="relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>From</p>
                                <div>
                                    <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                </div>
                            </div>
                            <div className=" relative rounded-md shadow-sm ml-3">
                                <p className='text-sm leading-3 text-gray-500'>To</p>
                                <div>
                                    <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                </div>
                            </div>
                            <div className='flex ml-3'>
                                <div className="mt-5 relative rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                    </div>
                                    <input
                                        type="text"
                                        name="user"
                                        id="user"
                                        onChange={(e) => searchDeposit(e.target.value)}
                                        className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                        placeholder="Search "
                                    />
                                    <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                        <div className='tooltip'>
                                            <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                            <span className="tooltiptext"> <p>Search by first name, trading name and account number</p></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mt-5 ml-4'>
                                <button
                                    onClick={range}
                                    className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                            </div>
                            <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                <select
                                    id="currency"
                                    name="currency"
                                    onChange={(e) => handleStatus(e.target.value)}
                                    placeholder="Sort by"
                                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                >
                                    <option>Sort by</option>
                                    <option value={"All"}>All</option>
                                    <option value={"Pending"}>Pending</option>
                                    <option value={"Approved"}>Approved</option>
                                    <option value={"Rejected"}>Rejected</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    {req.length === 0 ? (
                        <div className="mt-8"> No data available for these dates to show. </div>
                    ) : 
                    <>
                    <div className="mt-4 flex flex-col">
                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">

                                <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                        <thead>
                                            <tr>
                                                <th scope="col" className="min-w-[8rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-400">
                                                    User First Name
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400 ">
                                                    User Last Name
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Account Number
                                                </th>
                                                <th scope="col" className="min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Business Name
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Business Segment
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Business Outlet
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Number of Unit
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Status
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    Request  Date
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                </th>
                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-400">
                                                    <span className="sr-only">Edit</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200 bg-white">
                                            {req.map((person, i) => (
                                                <tr key={i} className="bg-gray-50">
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userFirstName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userLastName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.accountNumber}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.tradingName}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.businessSegment}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.businessOutlet}</td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.numberofPosUnit}</td>
                                                    <td><span className={classNames(
                                                        statusStyles[person.posStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.posStatus}</span></td>
                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>

                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                </>
                    }
                
                </div>

            </React.Fragment>
        </Layout></>)
}